import React from 'react'
import '../styles/vrar.css'
import Navbar from '../components/common/Navbar'
import VrArHero from '../components/vrar/VrArHero'
import VrMedia from '../components/vrar/VrMedia'
import VrServices from '../components/vrar/VrServices'

const VrArPage = () => {
    return (
        <div>
            <Navbar />
            <VrArHero />
            <VrMedia />
            <VrServices />
        </div>
    )
}

export default VrArPage